// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

:root {
  /* ─── Colores Existentes (SIN TOCAR) ──────────────────────────────── */
  --font-family-primary: "Brygada 1918", serif;
  --font-family-secondary: "Inter", sans-serif;
  --color-marron-principal: #3E0102;
  --color-marron-secundario: #28180b;
  --color-marron-tercero: #160000;
  --color-hogar: #B10002;
  --color-marron-cuarto: #280101;
  --color-bordo-secundario: #7C0405;
  --color-bordo-tercero: #560203;
  --color-bordo-cuarto: #6A0304;
  --color-titulo-marybe: #f2dc8f;
  --color-rosa-tercero: #D3C0C0;
  --color-fondo-beneficio-tarjeta: #FAF9F7;
  --color-blanco-pero-no-tan-blanco: #FAF0F0;
  --color-blanco: #FFFFFF;
  --color-fondo-tarjetas-promo: #F6F4F0;
  --color-fondo-info-promo: #e7e2da;
  --color-boton-promo: #7C0405;

  /* Gift card — paleta crema y dorada de la tarjeta */
  --color-giftcard-crema: #F7F3EC;
  --color-giftcard-borde: #E6DECF;
  --color-giftcard-oro: #C2A15C;

  /* ─── Espaciados Estándar (Spacing Tokens) ───────────────────────── */
  --spacing-xs: 0.25rem;
  /* 4px */
  --spacing-sm: 0.5rem;
  /* 8px */
  --spacing-md: 1rem;
  /* 16px */
  --spacing-lg: 1.5rem;
  /* 24px */
  --spacing-xl: 2rem;
  /* 32px */
  --spacing-xxl: 3rem;
  /* 48px */

  /* ─── Bordes y Radios (Borders & Radius) ────────────────────────── */
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-xl: 20px;
  --radius-full: 9999px;

  /* ─── Sombras Premium (Box Shadows) ──────────────────────────────── */
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-inner: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);

  /* ─── Transiciones Suaves (Transitions) ──────────────────────────── */
  --transition-fast: all 0.15s ease;
  --transition-normal: all 0.3s ease;
  --transition-slow: all 0.5s ease;
}

/* ─── 1. Reset Global Mejorado (Avanzado) ─────────────────────────── */
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Evita que los scrolls salten bruscamente */
html {
  scroll-behavior: smooth;
  height: 100%;
  overflow-x: hidden;
  max-width: 100vw;
}

/* Altura mínima del cuerpo y bases de renderizado de texto */
body {
  min-height: 100%;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--color-marron-tercero);
  color: var(--color-blanco-pero-no-tan-blanco);
  font-family: var(--font-family-secondary);
  line-height: 1.6;
  overflow-x: hidden;
  max-width: 100vw;
}

#root {
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
}

/* ─── 2. Elementos de Medios e Imágenes ───────────────────────────── */
/* Evita desbordamientos y quita el espacio en blanco inferior por defecto */
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
  height: auto;
  object-fit: cover;
}

/* ─── 3. Formularios e Interactivos (Herencia Tipográfica) ───────── */
input,
button,
textarea,
select {
  font: inherit;
  color: inherit;
  background: transparent;
  border: none;
}

button {
  cursor: pointer;
}

/* Estilo accesible para focos por teclado */
button:focus-visible,
input:focus-visible,
textarea:focus-visible,
select:focus-visible {
  outline: 2px solid var(--color-titulo-marybe);
  outline-offset: 2px;
}

/* ─── 4. Tipografía Estándar e Jerárquica ────────────────────────── */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--font-family-primary);
  font-weight: 600;
  line-height: 1.25;
  color: var(--color-titulo-marybe);
}

h1 {
  font-size: 2.5rem;
}

h2 {
  font-size: 2rem;
}

h3 {
  font-size: 1.75rem;
}

h4 {
  font-size: 1.5rem;
}

h5 {
  font-size: 1.25rem;
}

h6 {
  font-size: 1rem;
}

p {
  margin-bottom: var(--spacing-sm);
  color: var(--color-bordo-tercero);
}

a {
  color: inherit;
  text-decoration: none;
  transition: var(--transition-fast);
}

/* ─── 5. Clases de Utilidad Comunes e Indispensables ─────────────── */

/* Ocultar elementos visualmente pero mantenerlos legibles para lectores de pantalla (Accesibilidad) */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Contenedor central estándar */
.container {
  width: 100%;
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;
  padding-right: var(--spacing-md);
  padding-left: var(--spacing-md);
}

/* Scrollbars personalizadas premium acordes a la estética oscura */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: var(--color-marron-tercero);
}

::-webkit-scrollbar-thumb {
  background: var(--color-marron-secundario);
  border-radius: var(--radius-full);
}

::-webkit-scrollbar-thumb:hover {
  background: var(--color-marron-principal);
}

/* Estilo para la selección de texto */
::selection {
  background-color: var(--color-marron-principal);
  color: var(--color-titulo-marybe);
}
/* iOS: evita el zoom automático al enfocar inputs (se dispara con font-size < 16px).
   Forzamos 16px en mobile sin desactivar el pinch-zoom del usuario. */
@media (max-width: 768px) {
  input[type="text"],
  input[type="search"],
  input[type="number"],
  input[type="email"],
  input[type="tel"],
  input[type="password"],
  input[type="url"],
  input:not([type]),
  select,
  textarea {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";;AAEA;EACE,wEAAwE;EACxE,4CAA4C;EAC5C,4CAA4C;EAC5C,iCAAiC;EACjC,kCAAkC;EAClC,+BAA+B;EAC/B,sBAAsB;EACtB,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;EAC7B,wCAAwC;EACxC,0CAA0C;EAC1C,uBAAuB;EACvB,qCAAqC;EACrC,iCAAiC;EACjC,4BAA4B;;EAE5B,oDAAoD;EACpD,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;;EAE7B,uEAAuE;EACvE,qBAAqB;EACrB,QAAQ;EACR,oBAAoB;EACpB,QAAQ;EACR,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,SAAS;;EAET,sEAAsE;EACtE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;;EAErB,uEAAuE;EACvE,4CAA4C;EAC5C,kFAAkF;EAClF,oFAAoF;EACpF,qDAAqD;;EAErD,uEAAuE;EACvE,iCAAiC;EACjC,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA,wEAAwE;AACxE;;;EAGE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,6CAA6C;AAC7C;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,gBAAgB;EAChB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,6CAA6C;EAC7C,6CAA6C;EAC7C,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wEAAwE;AACxE,4EAA4E;AAC5E;;;;;EAKE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA,uEAAuE;AACvE;;;;EAIE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;;;;EAIE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;;;;;;EAME,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA,uEAAuE;;AAEvE,sGAAsG;AACtG;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA,mEAAmE;AACnE;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,sCAAsC;AACtC;EACE,+CAA+C;EAC/C,iCAAiC;AACnC;AACA;sEACsE;AACtE;EACE;;;;;;;;;;IAUE,eAAe;EACjB;AACF","sourcesContent":["\n\n:root {\n  /* ─── Colores Existentes (SIN TOCAR) ──────────────────────────────── */\n  --font-family-primary: \"Brygada 1918\", serif;\n  --font-family-secondary: \"Inter\", sans-serif;\n  --color-marron-principal: #3E0102;\n  --color-marron-secundario: #28180b;\n  --color-marron-tercero: #160000;\n  --color-hogar: #B10002;\n  --color-marron-cuarto: #280101;\n  --color-bordo-secundario: #7C0405;\n  --color-bordo-tercero: #560203;\n  --color-bordo-cuarto: #6A0304;\n  --color-titulo-marybe: #f2dc8f;\n  --color-rosa-tercero: #D3C0C0;\n  --color-fondo-beneficio-tarjeta: #FAF9F7;\n  --color-blanco-pero-no-tan-blanco: #FAF0F0;\n  --color-blanco: #FFFFFF;\n  --color-fondo-tarjetas-promo: #F6F4F0;\n  --color-fondo-info-promo: #e7e2da;\n  --color-boton-promo: #7C0405;\n\n  /* Gift card — paleta crema y dorada de la tarjeta */\n  --color-giftcard-crema: #F7F3EC;\n  --color-giftcard-borde: #E6DECF;\n  --color-giftcard-oro: #C2A15C;\n\n  /* ─── Espaciados Estándar (Spacing Tokens) ───────────────────────── */\n  --spacing-xs: 0.25rem;\n  /* 4px */\n  --spacing-sm: 0.5rem;\n  /* 8px */\n  --spacing-md: 1rem;\n  /* 16px */\n  --spacing-lg: 1.5rem;\n  /* 24px */\n  --spacing-xl: 2rem;\n  /* 32px */\n  --spacing-xxl: 3rem;\n  /* 48px */\n\n  /* ─── Bordes y Radios (Borders & Radius) ────────────────────────── */\n  --radius-sm: 4px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n  --radius-xl: 20px;\n  --radius-full: 9999px;\n\n  /* ─── Sombras Premium (Box Shadows) ──────────────────────────────── */\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --shadow-inner: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n\n  /* ─── Transiciones Suaves (Transitions) ──────────────────────────── */\n  --transition-fast: all 0.15s ease;\n  --transition-normal: all 0.3s ease;\n  --transition-slow: all 0.5s ease;\n}\n\n/* ─── 1. Reset Global Mejorado (Avanzado) ─────────────────────────── */\n*,\n*::before,\n*::after {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Evita que los scrolls salten bruscamente */\nhtml {\n  scroll-behavior: smooth;\n  height: 100%;\n  overflow-x: hidden;\n  max-width: 100vw;\n}\n\n/* Altura mínima del cuerpo y bases de renderizado de texto */\nbody {\n  min-height: 100%;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--color-marron-tercero);\n  color: var(--color-blanco-pero-no-tan-blanco);\n  font-family: var(--font-family-secondary);\n  line-height: 1.6;\n  overflow-x: hidden;\n  max-width: 100vw;\n}\n\n#root {\n  width: 100%;\n  max-width: 100vw;\n  overflow-x: hidden;\n}\n\n/* ─── 2. Elementos de Medios e Imágenes ───────────────────────────── */\n/* Evita desbordamientos y quita el espacio en blanco inferior por defecto */\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  object-fit: cover;\n}\n\n/* ─── 3. Formularios e Interactivos (Herencia Tipográfica) ───────── */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n  color: inherit;\n  background: transparent;\n  border: none;\n}\n\nbutton {\n  cursor: pointer;\n}\n\n/* Estilo accesible para focos por teclado */\nbutton:focus-visible,\ninput:focus-visible,\ntextarea:focus-visible,\nselect:focus-visible {\n  outline: 2px solid var(--color-titulo-marybe);\n  outline-offset: 2px;\n}\n\n/* ─── 4. Tipografía Estándar e Jerárquica ────────────────────────── */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: var(--font-family-primary);\n  font-weight: 600;\n  line-height: 1.25;\n  color: var(--color-titulo-marybe);\n}\n\nh1 {\n  font-size: 2.5rem;\n}\n\nh2 {\n  font-size: 2rem;\n}\n\nh3 {\n  font-size: 1.75rem;\n}\n\nh4 {\n  font-size: 1.5rem;\n}\n\nh5 {\n  font-size: 1.25rem;\n}\n\nh6 {\n  font-size: 1rem;\n}\n\np {\n  margin-bottom: var(--spacing-sm);\n  color: var(--color-bordo-tercero);\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n  transition: var(--transition-fast);\n}\n\n/* ─── 5. Clases de Utilidad Comunes e Indispensables ─────────────── */\n\n/* Ocultar elementos visualmente pero mantenerlos legibles para lectores de pantalla (Accesibilidad) */\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Contenedor central estándar */\n.container {\n  width: 100%;\n  max-width: 1200px;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: var(--spacing-md);\n  padding-left: var(--spacing-md);\n}\n\n/* Scrollbars personalizadas premium acordes a la estética oscura */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--color-marron-tercero);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--color-marron-secundario);\n  border-radius: var(--radius-full);\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--color-marron-principal);\n}\n\n/* Estilo para la selección de texto */\n::selection {\n  background-color: var(--color-marron-principal);\n  color: var(--color-titulo-marybe);\n}\n/* iOS: evita el zoom automático al enfocar inputs (se dispara con font-size < 16px).\n   Forzamos 16px en mobile sin desactivar el pinch-zoom del usuario. */\n@media (max-width: 768px) {\n  input[type=\"text\"],\n  input[type=\"search\"],\n  input[type=\"number\"],\n  input[type=\"email\"],\n  input[type=\"tel\"],\n  input[type=\"password\"],\n  input[type=\"url\"],\n  input:not([type]),\n  select,\n  textarea {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
